import React from 'react';
import Option from '../option';
import Scrollbar from '../../scrollbar';
import useStyles from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var OptionsList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    highlightedIndex,
    highlightedRef,
    id,
    multiple = false,
    onClick,
    onKeyDown,
    onKeyPress,
    onMouseDown,
    onMouseMove,
    onScroll,
    options,
    visibleOptions = 10
  } = _ref;
  var [optionsHeight, setOptionsHeight] = React.useState(undefined);
  React.useEffect(() => {
    var isScroll = visibleOptions < options.length;
    if (isScroll) {
      var optionHeight = 40;
      var paddingHeight = 8;
      var calcOptionsHeight = visibleOptions * optionHeight + paddingHeight;
      setOptionsHeight(calcOptionsHeight);
    }
  }, [options, visibleOptions]);
  var styles = useStyles({
    optionsHeight
  });
  var renderOptions = () => {
    var optionsList = [];
    var index = 0;
    options.forEach(option => {
      var isHighlighted = highlightedIndex === index;
      var isSelected = isHighlighted;
      index = option.divider ? index : index + 1;
      optionsList.push(___EmotionJSX(Option, {
        highlightedRef: highlightedRef,
        isHighlighted: isHighlighted,
        isSelected: isSelected,
        key: "op-".concat(option.value, "-").concat(index),
        multiple: multiple,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        option: option
      }));
    });
    return optionsList;
  };
  return ___EmotionJSX(Scrollbar, {
    "aria-multiselectable": multiple ? true : undefined,
    component: "ul",
    customStyle: styles,
    id: id,
    onScroll: onScroll,
    ref: ref,
    role: "listbox",
    tabIndex: -1
  }, renderOptions());
});
OptionsList.displayName = 'OptionsList';
export default OptionsList;